import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginApi } from "../../../../utils/apis/auth-service";
import { useAuth } from "../../../../utils/context/AuthContext";

export const useChangePasswordSuccess = () => {
    const { login } = useAuth();
    const navigate = useNavigate()
    const location = useLocation();

    const email = location?.state?.email ?? "";
    const password = location?.state?.password ?? "";

    const callLogin = useCallback(async () => {
        try {
            loginApi(
                email,
                password,
                (result) => {
                    login(
                        result.idToken,
                        result.userId,
                        result.accessToken,
                        result.refreshToken,
                        result.expiryTime,
                        result.role,
                    )
                    navigate(`/fetch-user-data`)
                },
                (error) => {
                }
            )
        } catch (error) {
            if (error instanceof Error) {
            }
            navigate("/login")
        }
    }, [email, password, navigate, login]);

    useEffect(() => {
        if (!email || !password) {
            navigate("/login");
            return;
        }
        const timer = setTimeout(() => {
            callLogin();
        }, 1500);

        return () => clearTimeout(timer);
    }, [callLogin, email, password, navigate]);

    return { email, password };
}